import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { ProductDataProvider } from "../../data-provider/product.dp";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";

let PlanInfoComponent = {
    selector: "vcPlanInfo",
    templateUrl: "/angular/components/campaign-plan/plan-info.component.html",
    bindings: {
        parentPlan: "=",
        size: "=",
        signup: "=",
        selectedPlanLevel: "=",
        conversionType: "=",
        selectedPlan: "=?",
        promotion: "=?",
        showPromo: "=?",
        plan: "=?",
    },
    controller: class PlanInfoController {
        // * bindings for typescript compiler *
        public parentPlan: any;
        public plan: any;
        public size: any;
        public signup: any;
        public conversionType: any;
        public selectedPlan?: any;
        public promotion?: any;
        public showPromo?: boolean = false;
        // ************************************

        public activeCampaign: Campaign;
        public paymentDate: any;
        public currency: string;
        public promoExplainer: string = "";
        public promoErrors = [];
        public promoLoading: boolean = false;
        public invoice: any;
        public invoiceLoading: boolean = false;

        private $scope: any;
        private __env: any;
        private campaignDataProvider: CampaignDataProvider;
        private subscriptionDataProvider: SubscriptionDataProvider;
        private productDataProvider: ProductDataProvider;

        public selectedPlanLevel: number;

        constructor(
            $scope: any,
            __env: any,
            CampaignDataProvider: CampaignDataProvider,
            SubscriptionDataProvider: SubscriptionDataProvider,
            ProductDataProvider: ProductDataProvider
        ) {
            this.$scope = $scope;
            this.__env = __env;

            this.campaignDataProvider = CampaignDataProvider;
            this.subscriptionDataProvider = SubscriptionDataProvider;
            this.productDataProvider = ProductDataProvider;

            this.activeCampaign = this.campaignDataProvider.getActiveCampaign();
        }

        $onInit() {
            if (!this.plan) {
                this.plan = this.parentPlan.plans[this.selectedPlanLevel];
            }

            if (!this.promotion) {
                this.promotion = {};
            }

            if (this.plan.cpcountry == "EU") {
                this.currency = "€";
            } else if (this.plan.cpcountry == "UK") {
                this.currency = "£";
            } else if (
                this.plan.cpcountry == "USA" ||
                this.plan.cpcountry == "US"
            ) {
                this.currency = "$";
            } else {
                this.currency = "$";
            }

            let d = new Date();
            this.plan.year = d.getFullYear();

            if (this.plan.cpname == "Legacy") {
                this.plan.cpname = "Essentials";
            }

            if (this.size == "large") {
                this.getInvoice();
            }

            if (this.activeCampaign && this.activeCampaign.campaignid) {
                this.paymentDate = this.activeCampaign.campaignexpire;
            } else {
                this.paymentDate = d;
                this.paymentDate.setDate(d.getDate());
            }
        }

        checkPromoCode(code, remove) {
            this.promoExplainer = "";
            this.promoErrors = [];
            this.promoLoading = true;
            this.subscriptionDataProvider.checkPromoCode(code).then(
                (result) => {
                    this.promoLoading = false;
                    this.promoExplainer =
                        this.productDataProvider.couponDescription(
                            result.coupon
                        );
                    _.merge(this.promotion, result);

                    this.getInvoice(this.promotion.coupon.id, remove);
                },
                (data) => {
                    this.promoErrors = data.message;
                    this.promoLoading = false;

                    if (this.promotion.id) {
                        this.getInvoice();
                    }
                }
            );
        }

        resetCode() {
            this.promotion.id = null;
            this.promotion.code = "";
            this.promoExplainer = "";
            this.promoErrors = [];
            this.promoLoading = false;
            this.getInvoice(null, true);
        }

        getInvoice(couponId?: any, removeCoupon?: boolean) {
            this.invoiceLoading = true;
            if (this.conversionType == "create") {
                this.productDataProvider
                    .previewFirstInvoice(
                        this.plan.cpstripeid,
                        couponId,
                        removeCoupon
                    )
                    .then((data) => {
                        this.invoice = data;
                        this.invoiceLoading = false;
                    });
            } else if (this.conversionType == "invoice") {
                this.productDataProvider
                    .previewNextInvoice(couponId, removeCoupon)
                    .then((data) => {
                        this.invoice = data;
                        this.invoiceLoading = false;
                        this.handlePromotion(this.invoice);
                    });
            } else {
                this.productDataProvider
                    .previewPlanChange(
                        this.plan.cpstripeid,
                        couponId,
                        removeCoupon,
                        this.conversionType
                    )
                    .then((data) => {
                        this.invoice = data;
                        this.invoiceLoading = false;
                        this.handlePromotion(this.invoice);
                    });
            }
        }

        handlePromotion(invoice) {
            if (invoice.promotion) {
                _.merge(this.promotion, invoice.promotion);
            }
            if (invoice.discount && invoice.discount.coupon) {
                this.promoExplainer =
                    this.productDataProvider.couponDescription(
                        invoice.discount.coupon
                    );
            }
        }

        changeLevel(planLevel: number): void {
            this.selectedPlanLevel = planLevel;
            this.plan = this.parentPlan.plans[this.selectedPlanLevel];
            this.selectedPlan = this.plan;
        }
    },
};

angular
    .module("campaignplan")
    .component(PlanInfoComponent.selector, PlanInfoComponent);
